import RiotControl from 'riotcontrol'

import { AnalyticsObservable } from './analytics-observable'
import { ApplicationObservableInstance } from './application-observable'
import { ApplicationApi } from './application-api-observable'
import { Authentication } from './authentication-observable'
import { BillingAddressInstance } from './billing-address'
import { CustomerInfo } from './customer-info'
import { CountriesObservable } from './countries-observable'
import { CouponsObservable } from './coupons-observable'
import { FulfillmentsObservable } from './fulfillments-observable'
import { GiftCards } from './gift-cards'
import { LineItemsInstance } from './line-items'
import { ModalFactoryObservable } from './modal-factory-observable'
import { OrderObservableInstance } from './order-observable'
import { ListsObservable } from './customer-lists-observable'
import { AvailabilityObservable } from './availability-observable'
import { TendersInstance } from './tenders'
import { ShippingChargesObservable } from './shipping-charges-observable'
import { StoresObservable } from './stores-observable'
import { TestsObservableInstance } from './tests-observable'

const applicationApi = new ApplicationApi()
const orderObsv = OrderObservableInstance
const AppObsv = ApplicationObservableInstance
const analyticsObsv = new AnalyticsObservable()
const authentication = new Authentication()
const billingAddress = BillingAddressInstance
const customerInfo = new CustomerInfo()
const countriesObservable = new CountriesObservable()
const couponsObservable = new CouponsObservable()
const fulfillmentsObservable = new FulfillmentsObservable()
const giftCards = new GiftCards()
const lineItems = LineItemsInstance;
const modalFactoryObsv = new ModalFactoryObservable()
const listsObservable = new ListsObservable()
const availabilityObservable = new AvailabilityObservable()
const tenders = TendersInstance
const shippingChargesObservable = new ShippingChargesObservable()
const storesObservable = new StoresObservable()
const testsObservable = TestsObservableInstance

function AddStores() {
  RiotControl.addStore(AppObsv)
  RiotControl.addStore(orderObsv)
  RiotControl.addStore(analyticsObsv)
  RiotControl.addStore(applicationApi)
  RiotControl.addStore(authentication)
  RiotControl.addStore(billingAddress)
  RiotControl.addStore(customerInfo)
  RiotControl.addStore(countriesObservable)
  RiotControl.addStore(couponsObservable)
  RiotControl.addStore(fulfillmentsObservable)
  RiotControl.addStore(giftCards)
  RiotControl.addStore(lineItems)
  RiotControl.addStore(modalFactoryObsv)
  RiotControl.addStore(listsObservable)
  RiotControl.addStore(availabilityObservable)
  RiotControl.addStore(tenders)
  RiotControl.addStore(shippingChargesObservable)
  RiotControl.addStore(storesObservable)
  RiotControl.addStore(testsObservable)
}
function registerObservables() {
  RiotControl.trigger('registerApplicationStateObserver', orderObsv)
  RiotControl.trigger('registerOrderObserver', AppObsv)
  RiotControl.trigger('registerOrderObserver', analyticsObsv)
  RiotControl.trigger('registerApplicationStateObserver', analyticsObsv)
  RiotControl.trigger('registerCountriesObserver', applicationApi)
  RiotControl.trigger('registerOrderObserver', authentication)
  RiotControl.trigger('registerOrderObserver', billingAddress)
  RiotControl.trigger('registerOrderObserver', customerInfo)
  RiotControl.trigger('registerOrderObserver', couponsObservable)
  RiotControl.trigger('registerOrderObserver', fulfillmentsObservable)
  RiotControl.trigger('registerOrderObserver', giftCards)
  RiotControl.trigger('registerOrderObserver', lineItems)
  RiotControl.trigger('registerOrderObserver', modalFactoryObsv)
  RiotControl.trigger('registerOrderObserver', listsObservable)
  RiotControl.trigger('registerOrderObserver', availabilityObservable)
  RiotControl.trigger('registerOrderObserver', tenders)
  RiotControl.trigger('registerApplicationStateObserver', tenders)
  RiotControl.trigger('updateOrderResource', 'tenders', tenders.model)
  RiotControl.trigger('registerOrderObserver', shippingChargesObservable)
  RiotControl.trigger('registerOrderObserver', storesObservable)
  RiotControl.trigger('registerOrderObserver', testsObservable)
}

AddStores()
registerObservables()